import Immutable from "seamless-immutable";

const initialState = Immutable({});

const UploadReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default UploadReducer;
